// TODO: CSS rule value must be moved into Theme folder.

import BezierEasing from "bezier-easing";
import Color from "color";
import * as theme from "./Theme";

export const LIST_STYLE_HYPHEN = "–";

/** Theme Setup */
export const color = theme.colors;
export const fonts = theme.fonts;
export const fontSizes = theme.fontSizes;
export const letterSpacings = theme.letterSpacings;
export const lineHeights = theme.lineHeights;
export const shadows = theme.shadows;

export const defaultButtonIconFontSize = 28;
export const defaultButtonIconSize = 16;

export const opacityElementDisabled = 0.5;

export const radius = "4px";
export const radius2 = "8px";
export const radius3 = "12px";

export const easingBounceMs = 250;
export const easingBounce = "cubic-bezier(0.54, 1.12, 0.38, 1.11)";
export const easingBounceJS = BezierEasing(0.54, 1.12, 0.38, 1.11);

export const easingSoftMs = 200;
export const easingSoft = "cubic-bezier(0.4, 1, 0.75, 0.9)";
export const easingSoftJS = BezierEasing(0.4, 1, 0.75, 0.9);

const lightestColors = new Map<string, string>();
export const lightest = (color: string) => {
  if (!lightestColors.has(color))
    lightestColors.set(color, Color(color).mix(Color("white"), 0.85).hex());
  return lightestColors.get(color)!;
};

export const shadow = {
  none: "0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0)",
  0: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  1: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  2: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  3: "0px 0px 16px rgba(32, 61, 89, 0.12)",
  4: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
};

export const zIndex = {
  none: 0,
  overPositionedElements: 1,
  sticky: 2,
  inlinePopper: 3,
  stickyFixed: 4,
  fixedSubheader: 5,
  sidePanel: 6,
  menu: 7,
  fixedHeader: 8,
  sidePanelButton: 9,
  modalOverlay: 10,
  modalPopper: 11,
  popper: 12,
  toast: 13,
  // spinner: 14,
};

const stableColors = new Map<string, string>();
function _stableColor(str: string) {
  let i = 0;
  let hash = 0;
  for (i = 0, hash = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash));
  const color = Math.floor(Math.abs(((Math.sin(hash) * 10000) % 1) * 16777216)).toString(16);
  return "#" + new Array(6 - color.length + 1).join("0") + color;
}

export function stableColor(str: string) {
  if (!stableColors.has(str)) stableColors.set(str, _stableColor(str));

  return stableColors.get(str)!;
}
